/**
 * CodeBlock — bloco de código dos artigos/chat da Ajuda com botão COPIAR.
 *
 * Usado como renderer de `pre` no react-markdown (ArticleView + HelpWidget).
 * Extrai o TEXTO puro do bloco (via childrenToText) e copia EXATO pro clipboard —
 * essencial pra comandos de CMD que precisam ser colados sem erro (uma linha só).
 * O texto quebra visualmente (pre-wrap) mas o copiado preserva a linha original.
 */
import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { childrenToText } from './articleMarkdown';

export default function CodeBlock({ children }) {
  const [copied, setCopied] = useState(false);
  const text = childrenToText(children).replace(/\n$/, '');

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard bloqueado — usuário seleciona manualmente */
    }
  };

  return (
    <span style={{ position: 'relative', display: 'block', margin: '10px 0' }}>
      <pre style={{
        background: '#0A0A0A', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px',
        padding: '12px 42px 12px 12px', margin: 0,
        overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
        fontSize: '12.5px', lineHeight: 1.55, color: 'var(--dp-text-primary)',
      }}>
        {text}
      </pre>
      <button
        onClick={copy}
        title={copied ? 'Copiado!' : 'Copiar'}
        aria-label="Copiar código"
        style={{
          position: 'absolute', top: '8px', right: '8px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '28px', height: '28px', borderRadius: '7px', cursor: 'pointer',
          background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)',
          color: copied ? '#34D399' : 'var(--dp-text-secondary)', transition: 'color .2s, background .2s',
        }}
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </span>
  );
}
